export default __webpack_public_path__ + "static/media/IconDesc_RampInverted_8x8x2.256.c82c649d.png";